import { DataStoreValue } from './DataStorePaneStateUtility';
import { DataStorePaths } from './DataStorePaths';
import {
  fixPrevNextForPane,
  interpolateLabelEncodings,
  interpolatePathWithMapping,
  PaneInterpolation,
  PaneInterpolationContext,
} from './PaneInterpolation';
import { PaneStateAttributeUtil } from './PaneStateAttribute';

export class SingleFractionPaneInterpolation implements PaneInterpolation {
  interpolatePane(
    context: PaneInterpolationContext,
    paneId: string,
    targetGetValue: (path: string) => DataStoreValue,
    fraction: number
  ): void {
    const markIdPath = `PDMarks.${paneId}.Encodings.MarkId`;
    const fromMarkIds = context.getValue(markIdPath);
    const toMarkIds = targetGetValue(markIdPath);
    const indexMapping = context.buildMarkIdIndexMapping(fromMarkIds, toMarkIds);

    for (const attribute of PaneStateAttributeUtil.getAllMarkAttributes()) {
      const path = DataStorePaths.getKeyPathForAttribute(paneId, attribute);
      if (!path) {
        continue;
      }
      interpolatePathWithMapping(context, targetGetValue, path, attribute, fraction, indexMapping);
    }

    interpolateLabelEncodings(context, paneId, targetGetValue, () => fraction);
    fixPrevNextForPane(context, paneId);
  }
}
